import React from 'react';
import { connect } from 'react-redux';
import { addTranslation, IntlProps } from 'decorators/addTranslation';
import ButtonsGroup from 'components/ui/buttonsGroup';
import Button from 'components/ui/button';
import { changeQuickFilter } from 'actions/quickFilters';
import { RootState, StoreProps } from 'store';
import { filtersKeysType } from 'types/Filters';
import tableNames from 'constants/tableNames';
import { etoPaymentsStatusConfig } from 'pages/payments/quickFiltersConfig.wl19';

interface ConnectedProps {
    activeValues: string[];
    statsConfig: any;
}

type Props = ConnectedProps & StoreProps & IntlProps;

class PaymentsStatsSection extends React.PureComponent<Props> {
    handleClick = (values: string[]) => {
        const { dispatch, statsConfig } = this.props;
        dispatch(changeQuickFilter(tableNames.payments, statsConfig.filterId as filtersKeysType, values));
    };

    render() {
        const { statsConfig, activeValues, getTranslate } = this.props;
        if (!statsConfig) return null;

        return (
            <div className='eto-stats-section'>
                <ButtonsGroup
                    activeButtons={activeValues}
                    mode={statsConfig.mode}
                    onClick={this.handleClick}
                    className='eto-stats-section__buttons'>
                    {statsConfig.list.map((btn) => (
                        <Button id={btn.id} key={btn.id} text={getTranslate(btn.text)} />
                    ))}
                </ButtonsGroup>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState, _ownProps): ConnectedProps => {
    const statsConfig = etoPaymentsStatusConfig;
    return {
        statsConfig,
        activeValues: statsConfig
            ? state.quickFilters[tableNames.payments]?.[statsConfig.filterId] ?? []
            : [],
    };
};

export default connect(mapStateToProps)(addTranslation(PaymentsStatsSection));
